import React from 'react';
import '../styles/getStarted.css';


const AboutInfo = () => {

  
  return (
    <section className="get-started ghgh">
      <h2 className="title">Our Core Value</h2>
      {/* <div className='follow'>Follow this steps to get started</div> */}
      <div className='blur'></div>
      <div className="steps steps1">
        <div className="step">
         
         <div className='bmLi' >
 

<svg fill="#38e3cb" height="80px" width="80px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" 
	 viewBox="0 0 442 442" >
<path d="M441.655,289.454c-1.087-4.487-5.104-7.647-9.72-7.647h-27.01l31.583-16.242c4.105-2.111,6.232-6.759,5.146-11.245
	c-1.087-4.487-5.104-7.647-9.72-7.647h-51.2l19.811-22.188c0.013-0.014,0.022-0.031,0.035-0.045
	c0.624-0.706,1.128-1.479,1.519-2.294c0.023-0.047,0.046-0.094,0.068-0.142c0.371-0.808,0.628-1.653,0.772-2.515
	c0.015-0.088,0.028-0.177,0.041-0.265c0.058-0.417,0.099-0.836,0.105-1.256c0-0.009,0.001-0.018,0.002-0.027
	c0.004-0.418-0.026-0.835-0.074-1.251c-0.013-0.115-0.029-0.228-0.046-0.342c-0.058-0.386-0.133-0.771-0.236-1.15
	c-0.009-0.034-0.014-0.069-0.024-0.103c-0.115-0.407-0.266-0.805-0.434-1.198c-0.022-0.052-0.034-0.106-0.057-0.158
	c-0.026-0.057-0.062-0.107-0.088-0.164c-0.155-0.33-0.327-0.652-0.52-0.967c-0.039-0.063-0.072-0.131-0.112-0.194
	c-0.211-0.327-0.451-0.642-0.704-0.948c-0.112-0.135-0.23-0.264-0.348-0.393c-0.073-0.079-0.137-0.163-0.213-0.241l-90.57-92.379
	L400.545,16.66c2.626-2.94,3.278-7.148,1.668-10.746C400.603,2.315,397.029,0,393.086,0H107.184c-2.849,0-5.562,1.215-7.459,3.34
	L2.604,112.112c-0.029,0.032-0.05,0.069-0.078,0.102c-0.29,0.333-0.56,0.677-0.798,1.037c-0.02,0.03-0.035,0.061-0.055,0.091
	c-0.222,0.342-0.416,0.696-0.592,1.057c-0.039,0.081-0.078,0.161-0.116,0.243c-0.357,0.786-0.606,1.607-0.748,2.446
	c-0.018,0.103-0.033,0.206-0.048,0.309c-0.055,0.4-0.093,0.801-0.1,1.204c0,0.021-0.003,0.042-0.004,0.063
	c-0.005,0.42,0.026,0.84,0.075,1.258c0.012,0.105,0.027,0.21,0.042,0.315c0.061,0.414,0.14,0.826,0.253,1.232
	c0.002,0.006,0.003,0.013,0.004,0.019c0.12,0.427,0.278,0.845,0.456,1.257c0.016,0.037,0.025,0.077,0.041,0.114
	c0.018,0.041,0.045,0.077,0.063,0.118c0.182,0.392,0.382,0.776,0.617,1.146c0.006,0.009,0.011,0.019,0.016,0.028
	c0.229,0.359,0.49,0.703,0.77,1.036c0.075,0.09,0.154,0.175,0.232,0.262c0.097,0.107,0.185,0.22,0.287,0.324l90.566,92.375
	L2.604,319.937c-0.031,0.034-0.053,0.074-0.083,0.108c-0.282,0.324-0.547,0.662-0.786,1.021c-0.028,0.042-0.05,0.085-0.077,0.127
	c-0.211,0.328-0.4,0.669-0.572,1.021c-0.04,0.082-0.08,0.162-0.118,0.245c-0.18,0.394-0.34,0.797-0.468,1.217
	c-0.002,0.007-0.003,0.015-0.006,0.022c-0.119,0.394-0.207,0.801-0.278,1.214c-0.018,0.105-0.034,0.21-0.048,0.316
	c-0.049,0.354-0.079,0.713-0.09,1.078c-0.002,0.074-0.011,0.147-0.011,0.221c0,0.023-0.003,0.046-0.003,0.069
	c0,0.407,0.031,0.806,0.079,1.2c0.011,0.095,0.029,0.188,0.043,0.283c0.055,0.366,0.128,0.726,0.221,1.078
	c0.02,0.075,0.036,0.15,0.058,0.225c0.124,0.429,0.275,0.846,0.453,1.25c0.007,0.017,0.011,0.034,0.018,0.051
	c0.017,0.038,0.04,0.07,0.058,0.107c0.167,0.36,0.354,0.707,0.561,1.042c0.043,0.069,0.082,0.14,0.126,0.208
	c0.231,0.355,0.483,0.695,0.756,1.017c0.058,0.069,0.121,0.132,0.181,0.2c0.234,0.262,0.481,0.51,0.741,0.746
	c0.072,0.065,0.142,0.132,0.215,0.195c0.318,0.271,0.651,0.524,1.002,0.755c0.058,0.038,0.118,0.071,0.176,0.107
	c0.315,0.198,0.642,0.377,0.98,0.54c0.076,0.037,0.15,0.075,0.226,0.109c0.394,0.178,0.798,0.334,1.217,0.46
	c0.036,0.011,0.073,0.018,0.108,0.028c0.375,0.108,0.761,0.191,1.153,0.256c0.104,0.017,0.208,0.034,0.313,0.048
	c0.43,0.057,0.866,0.096,1.312,0.096h285.902c0.38,0,0.756-0.025,1.129-0.067c0.117-0.013,0.232-0.038,0.349-0.056
	c0.256-0.039,0.51-0.08,0.761-0.137c0.136-0.031,0.269-0.072,0.403-0.109c0.229-0.063,0.455-0.129,0.678-0.208
	c0.138-0.049,0.273-0.104,0.409-0.158c0.215-0.086,0.427-0.179,0.635-0.28c0.069-0.033,0.141-0.057,0.209-0.092l65.496-33.683
	h24.589l-97.079,49.925H10.064c-5.523,0-10,4.478-10,10s4.477,10,10,10h285.902c1.591,0,3.158-0.38,4.573-1.107l65.496-33.683
	h24.588l-97.078,49.924H10.064c-5.523,0-10,4.478-10,10s4.477,10,10,10h285.902c1.591,0,3.158-0.38,4.573-1.107l65.495-33.682
	h24.589L293.545,422H10.064c-5.523,0-10,4.478-10,10s4.477,10,10,10h285.902c1.591,0,3.158-0.38,4.573-1.107l135.969-69.924
	c4.105-2.111,6.232-6.758,5.146-11.245c-1.087-4.487-5.104-7.647-9.72-7.647h-27.01l31.583-16.242
	c4.105-2.111,6.232-6.758,5.146-11.245c-1.087-4.487-5.104-7.647-9.72-7.647h-27.01l31.583-16.242
	C440.614,298.588,442.741,293.94,441.655,289.454z M390.624,266.672l-51.306,26.385l23.558-26.385H390.624z M32.399,316.597
	l79.263-88.772h135.897c5.522,0,10-4.478,10-10s-4.478-10-10-10H111.376l-77.504-79.052h36.692c5.523,0,10-4.478,10-10
	s-4.477-10-10-10H32.399L111.661,20h259.09l-79.263,88.772H110.553c-5.523,0-10,4.478-10,10s4.477,10,10,10h181.213l77.503,79.052
	h-81.723c-5.522,0-10,4.478-10,10s4.478,10,10,10h83.205l-79.263,88.772H32.399z"/>
</svg>
          {/* <svg className="svg-inline--fa fa-user-plus ggj" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-plus" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" data-fa-i2svg=""><path fill="currentColor" d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"></path></svg> */}
          </div>
          <h3 className="step-title step-title1">Continuous Improvement</h3>
          <p className="step-description">We aim to stay ahead of technology trends by improving solutions and creating innovative software that effectively solves complex problems.</p>
        </div>
        <div className="step">
        
          <div className='bmLi'>


<svg fill="#38e3cb" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" 
	 viewBox="0 0 477.297 477.297" width="80px" height="80px" >
<g>
	<g>
		<g>
			<path d="M42.85,358.075c0-24.138,0-306.758,0-330.917c23.9,0,278.867,0,302.767,0c0,8.542,0,49.44,0,99.722
				c5.846-1.079,11.842-1.812,17.99-1.812c3.149,0,6.126,0.647,9.232,0.928V0H15.649v385.233h224.638v-27.158
				C158.534,358.075,57.475,358.075,42.85,358.075z"/>
			<path d="M81.527,206.842h184.495c1.812-10.16,5.393-19.608,10.095-28.452H81.527V206.842z"/>
			<rect x="81.527" y="89.432" width="225.372" height="28.452"/>
			<path d="M81.527,295.822h191.268c5.112-3.106,10.57-5.63,16.415-7.183c-5.544-6.45-10.095-13.697-13.978-21.269H81.527V295.822z"
				/>
			<path d="M363.629,298.669c41.071,0,74.16-33.197,74.16-74.139c0-40.984-33.09-74.16-74.16-74.16
				c-40.898,0-74.009,33.176-74.009,74.16C289.62,265.472,322.731,298.669,363.629,298.669z"/>
			<path d="M423.143,310.706H304.288c-21.226,0-38.612,19.457-38.612,43.422v119.33c0,1.316,0.604,2.481,0.69,3.84h194.59
				c0.086-1.337,0.69-2.524,0.69-3.84v-119.33C461.733,330.227,444.39,310.706,423.143,310.706z"/>
		</g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
	<g>
	</g>
</g>
</svg>
            {/* <svg className="svg-inline--fa fa-wallet ggj" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="wallet" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H80c-8.8 0-16-7.2-16-16s7.2-16 16-16H448c17.7 0 32-14.3 32-32s-14.3-32-32-32H64zM416 272a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg> */}
            </div>
          <h3 className="step-title step-title1"> Client-Centric Approach</h3>
          <p className="step-description">
We are deeply committed to understanding clients' needs, ensuring tailored solutions that deliver results, fostering satisfaction, communication, and long-term partnerships.</p>
        </div>
      
        <div className="step">
      
        <div className='bmLi'>
          <svg width="80px" height="80px" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <g id="quality-5" transform="translate(-2 -2)">
    <circle id="secondary" fill="#38e3cb" cx="7" cy="7" r="7" transform="translate(5 3)"/>
    <path id="primary" d="M10,10l1.33,1.5L14,8.5" fill="none" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="primary-2" data-name="primary" d="M5.79,13.57,3,17.56l3.03.9L7.91,21l2.88-4.11" fill="#38e3cb" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <path id="primary-3" data-name="primary" d="M18.21,13.57,21,17.56l-3.03.9L16.09,21l-2.88-4.11" fill="#38e3cb" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    <circle id="primary-4" data-name="primary" cx="7" cy="7" r="7" transform="translate(5 3)" fill="none" stroke="#167c6e" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </g>
</svg>
          {/* <svg className="svg-inline--fa fa-chart-line ggj" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chart-line" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" data-fa-i2svg=""><path fill="currentColor" d="M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zm406.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L320 210.7l-57.4-57.4c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L240 221.3l57.4 57.4c12.5 12.5 32.8 12.5 45.3 0l128-128z"></path></svg> */}
          </div>
          <h3 className="step-title step-title1">Quality and Reliability</h3>
          <p className="step-description">We provide robust, scalable, and secure software solutions that meet industry standards, ensuring reliability and long-lasting value through thorough testing.</p>
        </div>
      </div>
    </section>
  );
};

export default AboutInfo;
